const INTRO_SEEN_PREFIX = 'introVideoSeen:';

export function getIntroSeenKey(username) {
  return `${INTRO_SEEN_PREFIX}${username}`;
}

export function hasSeenIntroVideo(username) {
  if (!username) return false;
  return localStorage.getItem(getIntroSeenKey(username)) === '1';
}

export function markIntroVideoSeen(username) {
  if (!username) return;
  localStorage.setItem(getIntroSeenKey(username), '1');
}

/** Karakter yokken yönlendirme: intro izlenmediyse /intro, aksi halde seçim ekranı. */
export function getOnboardingPath(username) {
  if (hasSeenIntroVideo(username)) {
    return '/character-selection';
  }
  return '/intro';
}
